/**
 * R2 - Maps Sanity icon name strings to React icon components
 * Used by sections that store icon names in the CMS
 * 
 * Add new icons here when expanding the Sanity content model
 */

import {
  FaKey,
  FaExchangeAlt,
  FaSync,
  FaTools,
  FaGraduationCap,
  FaHardHat,
  FaFutbol,
  FaHeartbeat,
  FaHotel,
  FaStore,
  FaWarehouse,
  FaToilet,
  FaShip,
  FaRecycle,
  FaBuilding,
  FaCubes,
  FaQuestionCircle,
} from 'react-icons/fa';

const ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  FaKey,
  FaExchangeAlt,
  FaSync,
  FaTools,
  FaGraduationCap,
  FaHardHat,
  FaFutbol,
  FaHeartbeat,
  FaHotel,
  FaStore,
  FaWarehouse,
  FaToilet,
  FaShip,
  FaRecycle,
  FaBuilding,
  FaCubes,
};

/**
 * Resolves a string icon name to a rendered React element.
 * Returns a fallback icon if the name is unknown.
 */
export function resolveIcon(
  iconName: string | undefined,
  className = 'h-8 w-8'
): React.ReactNode {
  const IconComponent = iconName ? ICON_MAP[iconName] : undefined;

  if (!IconComponent) {
    return <FaQuestionCircle className={className} />;
  }

  return <IconComponent className={className} />;
}
